import React from "react";
import { Badge } from "./Badge.jsx";
import { formatAppDate, dateSortValue } from "../utils/dateUtils.js";

/** Column builders for DataTable, so list pages declare columns in one line each. */

export const rupees = (value) => `₹${Number(value || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const paymentStatusVariant = (status) => (status === "Paid" ? "success" : status === "Partial" ? "warning" : "danger");

/** Date column; `getDateFormat(row)` returns the company's date pattern. */
export function dateColumn(key, label, getDateFormat) {
  return {
    key,
    label,
    width: 120,
    sortValue: (row) => dateSortValue(row[key]),
    render: (row) => formatAppDate(row[key], getDateFormat(row))
  };
}

/** Right-aligned ₹ column; `dashWhenZero` shows "—" for settled balances. */
export function moneyColumn(key, label, { dashWhenZero = false, width = 125 } = {}) {
  return {
    key,
    label,
    width,
    align: "right",
    className: "amount",
    sortValue: (row) => Number(row[key] || 0),
    render: (row) => (dashWhenZero && !(Number(row[key] || 0) > 0) ? <span className="text-dim">—</span> : rupees(row[key]))
  };
}

/** GST / Non-GST tag. */
export function gstTypeColumn(isNonGst) {
  return {
    key: "type",
    label: "Type",
    width: 90,
    optional: true,
    sortValue: (row) => (isNonGst(row) ? "Non-GST" : "GST"),
    render: (row) => (isNonGst(row) ? <span className="tag-muted">Non-GST</span> : <span className="tag-gst">GST</span>)
  };
}

/** Line-item count. */
export const itemCountColumn = {
  key: "items",
  label: "Items",
  width: 70,
  optional: true,
  align: "right",
  sortValue: (row) => (row.lineItems || []).length,
  render: (row) => (row.lineItems || []).length
};

/** Paid / Partial / Unpaid badge. */
export const paymentStatusColumn = {
  key: "paymentStatus",
  label: "Status",
  width: 105,
  render: (row) => <Badge variant={paymentStatusVariant(row.paymentStatus)}>{row.paymentStatus || "Unpaid"}</Badge>
};

/** Owning company (only useful when "All companies" is selected). */
export function companyColumn(getName) {
  return {
    key: "companyName",
    label: "Company",
    width: 180,
    optional: true,
    sortValue: (row) => getName(row) || "",
    render: (row) => getName(row) || "—"
  };
}
